import styled from "styled-components";

export const Container = styled.footer`
  padding: 20px 24px;
  border-radius: 8px;
  border: 1px solid var(--neutral-100, #E8E8E9);
  background: #FFF;
  max-width: 1120px;
  margin: 0 auto;

  position: fixed;
  z-index: 10001;
  bottom: 24px;
  right: 24px;
  left: 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: space-between;
  gap: 16px;

  > img {
    flex: 0 0 auto;
    width: 44px;
    height: auto;
  }

  button {
    flex: 0 0 auto;
    min-width: 164px;
    padding: 9px 18px;
    font-size: 13px;
  }

  .texto-mobile{
    display: none;
  }


  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: underline;
  }

  @media (max-width: 900px) {
    align-items: flex-start;
  }

  @media (max-width: 500px) {
    max-width: 100vw;
    padding: 18px 20px;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    left: 0;
    right: 0;
    bottom: 0;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;

    .texto-desktop{
      display: none;
    }
    
    .texto-mobile{
      display: block;
    }

    > img {
      width: 38px;
    }

    button {
      width: 100%;
      min-width: 0;
      padding: 9px 16px;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  min-width: 0;

  p {
    margin: 0 0 4px;
    color: #7a797a;
    font-size: 13px;
    line-height: 1.45;
  }

  a {
    font-size: 13px;
    line-height: 1.45;
  }

  @media (max-width: 500px) {
    text-align: center;
  }
`;
